export const generateApiUrl = (
  endPoint,
  path,
  productIdList,
  storeCode,
  additionalQueryStringParameters = ""
) => {
  return `${path}/product/catalogue/v4/${endPoint}?productIds=${productIdList}&store=${storeCode}${additionalQueryStringParameters}`;
};
